import { DatePicker, List } from "antd-mobile";
import dayjs from "dayjs";
import moment from "moment";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useUpdateEffect } from "react-use";
import styled from "styled-components";

interface SelectItemProps {
  dictionary: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  placeholder: string;
  children?: any;
  required?: boolean;
}

const DatePickerWrapper = styled.div`
  .am-list-item.am-list-item-middle .am-list-line {
    padding-right: 0;
  }
  .am-list-item .am-list-line .am-list-content {
    width: 100px;
    flex: 0 0 100px;
  }
  .am-list-item .am-list-line .am-list-extra {
    flex: 1;
    border-bottom: 1px solid #f3f1f1;
    padding-top: 15px;
    padding-right: 15px;
    min-height: 20px;
    text-align: left;
    padding-left: 15px;
  }
`;
export default forwardRef(
  (
    {
      dictionary,
      value,
      onChange,
      disabled,
      required,
      placeholder,
      children,
    }: SelectItemProps,
    ref: any
  ) => {
    const [dateValue, setDateValue] = useState<Date | undefined>(
      value ? new Date(value) : undefined
    );
    const [format, setFormat] = useState<string>("YYYY-MM-DD");

    useUpdateEffect(() => {
      onChange(dateValue ? dayjs(dateValue).format(format) : null);
    }, [dateValue]);

    return (
      <DatePickerWrapper>
        <DatePicker
          value={dateValue}
          format={format}
          disabled={disabled}
          extra={disabled ? " " : "请选择"}
          onChange={(date) => {
            setDateValue(date);
          }}>
          <List.Item>
            {required && (
              <span className="adm-form-item-label-required">*</span>
            )}
            {children}
          </List.Item>
        </DatePicker>
      </DatePickerWrapper>
    );
  }
);
